var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "crearGeneralSolicitudBajaClientes",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-form",
                {
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("v-flex", [
                            _c(
                              "h2",
                              {
                                staticClass: "h2_title",
                                staticStyle: { "margin-top": "12px !important" }
                              },
                              [
                                _vm._v(
                                  "\n                Datos Generales\n              "
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c("br"),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.numero.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.numero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.numero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.numero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _vm.esEjecutado
                                ? _c("v-text-field", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "movimiento",
                                      label: _vm.formFields.estado.label,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.estado.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.estado,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.estado.value"
                                    }
                                  })
                                : _c("v-autocomplete", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "movimiento",
                                      label: _vm.formFields.estado.label,
                                      items: _vm.estados,
                                      rules: [_vm.rules.required],
                                      disabled: _vm.esAnulado
                                    },
                                    on: { change: _vm.validarDatos },
                                    model: {
                                      value: _vm.formFields.estado.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.estado,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.estado.value"
                                    }
                                  })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "mr-2",
                                attrs: {
                                  label: _vm.formFields.motivoTipo.label,
                                  items: _vm.motivos,
                                  "item-text": "motiname",
                                  "item-value": "motiid",
                                  disabled: _vm.esAnulado,
                                  rules: [_vm.rules.required]
                                },
                                on: { change: _vm.validarDatos },
                                model: {
                                  value: _vm.formFields.motivoTipo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.motivoTipo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.motivoTipo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.observacion.label,
                                  disabled: _vm.esAnulado,
                                  rules: [_vm.rules.required]
                                },
                                on: { change: _vm.validarDatos },
                                model: {
                                  value: _vm.formFields.observacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.observacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.observacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "menu",
                                  attrs: {
                                    "close-on-content-click": false,
                                    "nudge-right": 40,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "max-width": "290px",
                                    "min-width": "290px"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    label:
                                                      _vm.formFields.tramo
                                                        .label,
                                                    "prepend-icon": "event",
                                                    readonly: "",
                                                    disabled: _vm.esAnulado
                                                  },
                                                  on: {
                                                    change: _vm.validarDatos
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formFields.tramo
                                                        .value,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formFields.tramo,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formFields.tramo.value"
                                                  }
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.menu,
                                    callback: function($$v) {
                                      _vm.menu = $$v
                                    },
                                    expression: "menu"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: {
                                        locale: "es-cl",
                                        type: "month",
                                        scrollable: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.menu = false
                                        }
                                      },
                                      model: {
                                        value: _vm.formFields.tramo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tramo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.tramo.value"
                                      }
                                    },
                                    [_c("v-spacer")],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.cantidadClientes.label,
                                  disabled: true,
                                  hint: _vm.datosActualizados
                                    ? "Datos actualizados a cambios en detalles"
                                    : "",
                                  "persistent-hint": ""
                                },
                                model: {
                                  value: _vm.formFields.cantidadClientes.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadClientes,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadClientes.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.cantidadEquipos.label,
                                  disabled: true,
                                  hint: _vm.datosActualizados
                                    ? "Datos actualizados a cambios en detalles"
                                    : "",
                                  "persistent-hint": ""
                                },
                                model: {
                                  value: _vm.formFields.cantidadEquipos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadEquipos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.cantidadEquipos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label:
                                    _vm.formFields.cantidadPerifericos.label,
                                  disabled: true,
                                  hint: _vm.datosActualizados
                                    ? "Datos actualizados a cambios en detalles"
                                    : "",
                                  "persistent-hint": ""
                                },
                                model: {
                                  value:
                                    _vm.formFields.cantidadPerifericos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadPerifericos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadPerifericos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.cantidadSimCards.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.cantidadSimCards.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadSimCards,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadSimCards.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label:
                                    _vm.formFields.cantidaEquiposConfirmados
                                      .label,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.cantidaEquiposConfirmados
                                      .value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidaEquiposConfirmados,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidaEquiposConfirmados.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }